<template>
  <IconLucideGift />
</template>
